<template>
  <div class="coursei">
    <div class="coursei-header" v-for="(item,index) in list" :key="index">
      <div class="coursei-header-son" @click="chang(item)">
        <div class="coursei-son-o">
          <img :src="item.thumb" alt />
        </div>
        <div class="coursei-son-t">
          <div>{{ item.title }}</div>
          <div style="height:50px;overflow:hidden;">{{ item.sentence_marking }}</div>
        </div>
        <div :class="libe==item.id ?'actives':'activess'"></div>
      </div>
    </div>
    <div class="course-button" @click="goteacher">确认</div>
  </div>
</template>
<script>
export default {
  name: "Membercoursei",
  data() {
    return {
      libe: 0,
      list: [],
      oblist: {},
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    async getlist() {
      let lists = await this.$http.get(`/api/student/course-systems`);
      this.list = lists.data;
      console.log(lists, "课程");
    },
    chang(e) {
      console.log(e,'课程体系id');
      this.$store.commit("changeCourseId", 
        e.id,
      );
      this.libe=e.id
      this.oblist=e
      localStorage.setItem('system_idss',e.id)
      console.log(this.libe);
    },
    goteacher() {
      this.$router.push({
          name:"Membercourselevel",
        //   query:{
        //       id:this.oblist.id
        //   }
      })
    },
  },
};
</script>
<style lang="scss">
.coursei {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 40px;
}
.coursei-header {
  background: #f6f8fa;
  width: 390px;
  height: 132px;
  display: flex;
  align-items: center;
  margin: 20px;
  .coursei-header-son {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    padding: 0 10px;
    .coursei-son-o {
      width: 66px;
      height: 66px;
      padding: 20px 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .coursei-son-t {
      width: 200px;
      margin: 20px 10px;
    }
  }
}
.course-button {
  line-height: 30px;
  width: 100px;
  text-align: center;
  background: #fd5624;
  color: #fff;
  position: absolute;
  bottom: 10px;
  left: 44%;
  cursor: pointer;
  right: 50px;
}
.activess {
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 50%;
}
.actives {
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background-image: url("../../images/goods/icon_commone_1@2x.png");
  background-size: 100%;
}
</style>
